export default "/assets/cb3d81038cf3a084.png"